/* Nórdico Nativo · panel de despacho a regiones en el carrito.
   Valores: mediana del flete Starken por pedido (ene 2024 – oct 2026). */
(function () {
  if (window.__nnDespacho) return;
  window.__nnDespacho = true;

  var ZONES = [
    { id: 'RM', name: 'Región Metropolitana', regions: ['Región Metropolitana'] },
    { id: 'NG', name: 'Norte Grande', regions: ['Arica y Parinacota', 'Tarapacá', 'Antofagasta'] },
    { id: 'NC', name: 'Norte Chico', regions: ['Atacama', 'Coquimbo'] },
    { id: 'C', name: 'Centro', regions: ['Valparaíso', "O'Higgins", 'Maule', 'Ñuble', 'Biobío'] },
    { id: 'S', name: 'Sur', regions: ['La Araucanía', 'Los Ríos', 'Los Lagos'] },
    { id: 'A', name: 'Austral', regions: ['Aysén', 'Magallanes'] }
  ];
  var DATA = {"COM_O|NG":{"n":11,"med":74000,"src":"zona"},"COM_O|NC":{"n":3,"med":61000,"src":"zona"},"COM_O|C":{"n":17,"med":51000,"src":"zona"},"COM_O|S":{"n":8,"med":48000,"src":"zona"},"COM_R|NG":{"n":6,"med":156000,"src":"zona"},"COM_R|NC":{"n":7,"med":54000,"src":"zona"},"COM_R|C":{"n":11,"med":64000,"src":"zona"},"COM_R|S":{"n":8,"med":80000,"src":"zona"},"CEN|NG":{"n":7,"med":41000,"src":"zona"},"CEN|NC":{"n":5,"med":20000,"src":"zona"},"CEN|C":{"n":34,"med":33000,"src":"zona"},"CEN|S":{"n":18,"med":33000,"src":"zona"},"LAT|NG":{"n":9,"med":34000,"src":"zona"},"LAT|NC":{"n":4,"med":18000,"src":"zona"},"LAT|C":{"n":32,"med":24000,"src":"zona"},"LAT|S":{"n":17,"med":23000,"src":"zona"},"JOY|NG":{"n":8,"med":7000,"src":"pais"},"JOY|NC":{"n":8,"med":7000,"src":"pais"},"JOY|C":{"n":4,"med":7000,"src":"zona"},"JOY|S":{"n":8,"med":7000,"src":"pais"}};
  var CAT_NAME = { COM_R: 'comedor rectangular', COM_O: 'comedor redondo', CEN: 'mesa de centro o estantería', LAT: 'mesa lateral, arrimo o silla', JOY: 'accesorio' };
  var WA = 'https://wa.me/56966854448';
  var KEY = 'nn-despacho-region';

  var css = '' +
    '.nn-desp{border:1px solid #e2dcd1;background:#fbf9f5;padding:12px 14px;margin:16px 0;font-size:14px;line-height:1.5}' +
    '.nn-desp p{margin:0}' +
    '.nn-desp .nn-desp-title{font-weight:600;font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#5a5a55;margin:0 0 2px}' +
    '.nn-desp-row{display:flex;align-items:center;gap:10px;padding:9px 0}' +
    '.nn-desp-row + .nn-desp-row{border-top:1px solid #ece7de}' +
    '.nn-desp-ico{flex:none;width:34px;height:34px;border-radius:50%;background:#fff;border:1px solid #e2dcd1;display:flex;align-items:center;justify-content:center;color:#5a5a55}' +
    '.nn-desp-txt{flex:1;min-width:0;display:flex;flex-direction:column}' +
    '.nn-desp-txt b{font-weight:600;font-size:13.5px}' +
    '.nn-desp-txt span{font-size:12px;color:#8a8680}' +
    '.nn-desp-val{font-weight:600;font-size:13px;white-space:nowrap}' +
    '.nn-desp-ok{color:#2f5d34}' +
    '.nn-desp-btn{display:flex;align-items:center;justify-content:center;width:100%;margin-top:9px;height:40px;border:1px solid #1c1c1a;border-radius:20px;background:#fff;color:#1c1c1a;font:inherit;font-size:13.5px;cursor:pointer;text-decoration:none}' +
    '.nn-desp-link{background:none;border:0;padding:6px 0 0;font:inherit;font-size:14px;color:inherit;text-decoration:underline;cursor:pointer}' +
    '#offcanvas-cart .nn-hide, p.nn-hide, .nn-hide{display:none!important}' +
    '.nn-sheet-bg{position:fixed;inset:0;background:rgba(28,28,26,.45);z-index:2000;opacity:0;transition:opacity .2s}' +
    '.nn-sheet{position:fixed;left:0;right:0;bottom:0;z-index:2001;background:#fff;color:#1c1c1a;border-radius:16px 16px 0 0;padding:10px 20px calc(22px + env(safe-area-inset-bottom));max-width:560px;margin:0 auto;box-shadow:0 -8px 30px rgba(28,28,26,.18);transform:translateY(100%);transition:transform .25s ease;display:flex;flex-direction:column;gap:14px;font-size:15px}' +
    '.nn-sheet.is-open{transform:none}.nn-sheet-bg.is-open{opacity:1}' +
    '.nn-sheet-handle{width:40px;height:4px;border-radius:2px;background:#d9d3c8;align-self:center}' +
    '.nn-sheet-head{display:flex;justify-content:space-between;align-items:center}' +
    '.nn-sheet-head h2{margin:0;font-size:22px}' +
    '.nn-sheet-x{width:44px;height:44px;border:0;background:transparent;font-size:24px;line-height:1;cursor:pointer;color:inherit}' +
    '.nn-sheet label{display:flex;flex-direction:column;gap:6px;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#5a5a55}' +
    '.nn-sheet select{height:48px;border:1px solid #d9d3c8;border-radius:6px;padding:0 12px;font:inherit;font-size:16px;letter-spacing:0;text-transform:none;color:#1c1c1a;background:#fff}' +
    '.nn-sheet-res{background:#f7f4ef;padding:14px 16px;display:flex;flex-direction:column;gap:4px}' +
    '.nn-sheet-res small{font-size:13px;color:#5a5a55}' +
    '.nn-sheet-big{font-size:28px;font-weight:600;line-height:1.2}' +
    '.nn-sheet-note{font-size:13px;color:#5a5a55;margin:0}' +
    '.nn-sheet-go{height:50px;border:0;border-radius:25px;background:#1c1c1a;color:#fff;font:inherit;font-size:15px;cursor:pointer}' +
    '.nn-disc{border:1px solid #e2dcd1;padding:14px 16px;margin:12px 0 16px;background:#fff}' +
    '.nn-disc label{display:block;font-size:14px;font-weight:600;margin:0 0 8px;color:#1c1c1a}' +
    '.nn-disc-row{display:flex;gap:8px}' +
    '.nn-disc input{flex:1;min-width:0;height:46px;border:1px solid #1c1c1a;border-radius:6px;padding:0 12px;font:inherit;font-size:16px;text-transform:uppercase;letter-spacing:.04em;color:#1c1c1a;background:#fff}' +
    '.nn-disc input::placeholder{text-transform:none;letter-spacing:0;color:#8a8680}' +
    '.nn-disc input:focus{outline:2px solid #1c1c1a;outline-offset:1px}' +
    '.nn-disc button{height:46px;padding:0 18px;border:0;border-radius:6px;background:#1c1c1a;color:#fff;font:inherit;font-size:14px;font-weight:600;cursor:pointer;white-space:nowrap}' +
    '.nn-disc-msg{display:block;font-size:12.5px;color:#5a5a55;margin-top:6px}' +
    '.nn-disc-msg.is-err{color:#b3261e}' +
    '.nn-vsw{margin-top:12px}' +
    '.nn-vsw-label{display:block;font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:#5a5a55;margin:0 0 4px}' +
    '.nn-vsw select{width:100%;height:44px;border:1px solid #d9d3c8;border-radius:6px;padding:0 36px 0 12px;font-size:14px;color:#1c1c1a;background-color:#fff}' +
    '.nn-vsw select:focus{border-color:#1c1c1a;box-shadow:none}' +
    '.nn-rev2{background:#f7f4ef;padding:14px 16px;margin:12px 0;text-align:center;font-size:13px;line-height:1.5}' +
    '.nn-rev2-head{color:#b8955a;letter-spacing:2px;font-size:12px;margin-bottom:5px}' +
    '.nn-rev2-head span{color:#5a5a55;letter-spacing:0;font-size:11.5px}' +
    '.nn-rev2-slide{display:none}.nn-rev2-slide.is-on{display:block}' +
    '.nn-rev2-slide p{margin:0;color:#3d3d3a}' +
    '.nn-rev2-slide small{display:block;font-size:11px;color:#8a8680;margin-top:4px}' +
    '.nn-rev2-nav{display:flex;align-items:center;justify-content:center;gap:4px;margin-top:6px}' +
    '.nn-rev2-arrow{width:40px;height:40px;border:0;background:none;color:#1c1c1a;font-size:22px;line-height:1;cursor:pointer;padding:0}' +
    '.nn-rev2-dots{display:flex;gap:4px;justify-content:center}' +
    '.nn-rev2-dot{width:8px;height:8px;padding:6px;border:0;background:none;cursor:pointer;position:relative}' +
    '.nn-rev2-dot::after{content:"";position:absolute;inset:3px;border-radius:50%;background:#d9d3c8}' +
    '.nn-rev2-dot.is-on::after{background:#1c1c1a}' +
    '.nn-foot-note{font-size:11.5px;color:#5a5a55;text-align:center;margin:8px 0 0}' +
    '.nn-btn-total{margin-left:8px;font-weight:500}' +
    '.product-item-title,.product-item-title a{font-family:Georgia,\"Times New Roman\",serif!important;font-size:15.5px!important;font-weight:400!important;line-height:1.35!important;letter-spacing:0!important;color:#1c1c1a!important;text-decoration:none!important}' +
    '.product-item-title{display:-webkit-box!important;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden!important;min-height:2.7em!important;padding-bottom:0!important;margin-bottom:4px!important}' +
    '.product-item-price{font-size:13px!important;padding-bottom:12px!important}' +
    '.product-item-price-final{font-family:\"Jost\",sans-serif!important;font-size:16px!important;font-weight:600!important;color:#1c1c1a!important;border:none!important;border-radius:0!important;padding:0!important;background:none!important;letter-spacing:-.01em!important}' +
    '.product-item-price-compare,.product-item-price-compare s{font-size:13px!important;font-weight:400!important;color:#8a8680!important}' +
    '.nn-float-hidden{visibility:hidden!important}' +
    '@media (prefers-reduced-motion:reduce){.nn-sheet,.nn-sheet-bg{transition:none}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function clp(n) { return '$' + Math.round(n).toLocaleString('es-CL'); }
  function zoneOf(r) { for (var i = 0; i < ZONES.length; i++) if (ZONES[i].regions.indexOf(r) > -1) return ZONES[i]; return null; }
  function getSaved() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
  function save(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  var bg, sheet, sel, res, lastBtn, cat;

  function build() {
    bg = document.createElement('div');
    bg.className = 'nn-sheet-bg';
    sheet = document.createElement('div');
    sheet.className = 'nn-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-labelledby', 'nn-sheet-t');
    var opts = '<option value="">Elige tu región</option>';
    ZONES.forEach(function (z) {
      opts += '<optgroup label="' + z.name + '">';
      z.regions.forEach(function (r) { opts += '<option value="' + r + '">' + r + '</option>'; });
      opts += '</optgroup>';
    });
    sheet.innerHTML =
      '<div class="nn-sheet-handle" aria-hidden="true"></div>' +
      '<div class="nn-sheet-head"><h2 id="nn-sheet-t">Despacho a tu región</h2><button type="button" class="nn-sheet-x" aria-label="Cerrar">×</button></div>' +
      '<label>Tu región<select>' + opts + '</select></label>' +
      '<div class="nn-sheet-res" aria-live="polite"></div>' +
      '<button type="button" class="nn-sheet-go">Seguir con mi compra</button>';
    document.body.appendChild(bg);
    document.body.appendChild(sheet);
    sel = sheet.querySelector('select');
    res = sheet.querySelector('.nn-sheet-res');
    sel.addEventListener('change', function () { save(sel.value); render(); });
    bg.addEventListener('click', close);
    sheet.querySelector('.nn-sheet-x').addEventListener('click', close);
    sheet.querySelector('.nn-sheet-go').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) close(); });
  }

  function render() {
    var r = sel.value, z = zoneOf(r);
    if (!z) { res.innerHTML = '<small>Elige tu región para ver el valor aproximado del despacho de este pedido.</small>'; return; }
    if (z.id === 'RM') { res.innerHTML = '<small>Región Metropolitana</small><div class="nn-sheet-big">Gratis</div><small>Con instalación incluida.</small>'; return; }
    var d = DATA[cat + '|' + z.id];
    if (!d) {
      res.innerHTML = '<small>' + r + '</small><div class="nn-sheet-big">Te lo cotizamos</div><small>Tenemos pocos envíos a tu zona para dar un valor confiable. <a href="' + WA + '" target="_blank" rel="noopener">Escríbenos por WhatsApp</a> y te decimos el valor para tu comuna.</small>';
      return;
    }
    var basis = d.src === 'zona'
      ? 'Valor típico de ' + d.n + ' pedidos parecidos (' + CAT_NAME[cat] + ') enviados a la zona ' + z.name + '.'
      : 'Valor típico de envíos de ' + CAT_NAME[cat] + ' a regiones.';
    res.innerHTML = '<small>Para este pedido · ' + r + '</small><div class="nn-sheet-big">aprox. ' + clp(d.med) + '</div>' +
      '<small>Por Starken, pagas al recibir. El monto final depende del peso, las medidas y tu comuna.</small>' +
      '<p class="nn-sheet-note" style="margin-top:6px">' + basis + '</p>';
  }

  function open(btn) {
    var box = btn.closest('[data-nn-desp]');
    cat = box ? box.getAttribute('data-cat') : '';
    if (!cat) return;
    if (!sheet) build();
    // Dentro del carrito lateral, el panel va dentro del offcanvas para no chocar con su bloqueo de foco.
    var host = btn.closest('.offcanvas') || document.body;
    if (sheet.parentNode !== host) { host.appendChild(bg); host.appendChild(sheet); }
    lastBtn = btn;
    var saved = getSaved();
    sel.value = zoneOf(saved) ? saved : '';
    render();
    bg.style.display = 'block'; sheet.style.display = 'flex';
    requestAnimationFrame(function () { bg.classList.add('is-open'); sheet.classList.add('is-open'); });
    floats(true);
    sel.focus();
  }

  function close() {
    bg.classList.remove('is-open'); sheet.classList.remove('is-open');
    setTimeout(function () { bg.style.display = 'none'; sheet.style.display = 'none'; }, 260);
    if (!document.querySelector('#offcanvas-cart.show')) floats(false);
    if (lastBtn && document.body.contains(lastBtn)) lastBtn.focus();
  }

  // Oculta botones flotantes de terceros (chat, WhatsApp) mientras el carrito o el panel están abiertos.
  function floats(hide) {
    var kids = document.body.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (hide) {
        if (el === bg || el === sheet || el.id === 'offcanvas-cart-wrapper') continue;
        var cls = (el.className && el.className.toString()) || '';
        if (/offcanvas|modal/.test(cls)) continue;
        var cs = getComputedStyle(el);
        if (cs.position === 'fixed' && cs.visibility !== 'hidden' && el.getBoundingClientRect().width < 200) el.classList.add('nn-float-hidden');
      } else {
        el.classList.remove('nn-float-hidden');
      }
    }
  }
  document.addEventListener('shown.bs.offcanvas', function (e) { if (e.target && e.target.id === 'offcanvas-cart') floats(true); });
  document.addEventListener('hidden.bs.offcanvas', function (e) { if (e.target && e.target.id === 'offcanvas-cart') floats(false); });

  // Código de descuento: valida y aplica el código en el pago.
  function applyDiscount(btn) {
    var box = btn.closest('.nn-disc');
    var input = box.querySelector('input');
    var msg = box.querySelector('.nn-disc-msg');
    var code = (input.value || '').trim();
    if (!code) { msg.textContent = 'Escribe tu código para aplicarlo.'; msg.classList.add('is-err'); input.focus(); return; }
    msg.classList.remove('is-err');
    msg.textContent = 'Aplicando código…';
    btn.disabled = true;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest && e.target.closest('.nn-disc input')) {
      e.preventDefault(); applyDiscount(e.target.closest('.nn-disc').querySelector('button'));
    }
  });

  // Carrusel de reseñas del carrito: rota cada 3,5 s, con flechas, puntos y deslizamiento.
  function initRev() {
    document.querySelectorAll('[data-nn-rev]').forEach(function (box) {
      if (box.dataset.nnInit) return;
      box.dataset.nnInit = '1';
      var slides = box.querySelectorAll('.nn-rev2-slide');
      var dots = box.querySelectorAll('.nn-rev2-dot');
      if (slides.length < 2) return;
      var i = 0, t;
      function go(n) {
        slides[i].classList.remove('is-on'); if (dots[i]) dots[i].classList.remove('is-on');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-on'); if (dots[i]) dots[i].classList.add('is-on');
      }
      function arm() { t = setInterval(function () {
        if (!document.contains(box)) { clearInterval(t); return; }
        go(i + 1);
      }, 3500); }
      box.addEventListener('click', function (e) {
        var a = e.target.closest('.nn-rev2-arrow');
        if (a) { go(i + parseInt(a.dataset.go, 10)); clearInterval(t); arm(); return; }
        var d = e.target.closest('.nn-rev2-dot');
        if (!d) return;
        go(parseInt(d.dataset.i, 10)); clearInterval(t); arm();
      });
      var x0 = null;
      box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; clearInterval(t); }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (x0 !== null) {
          var dx = e.changedTouches[0].clientX - x0;
          if (dx < -35) go(i + 1); else if (dx > 35) go(i - 1);
        }
        x0 = null; arm();
      }, { passive: true });
      arm();
    });
  }

  // Pie compacto del carrito lateral: total dentro del boton, sin bloque de subtotal,
  // y la tarjeta de resenas se mueve al final del carrito.
  function compactFooter() {
    var oc = document.querySelector('#offcanvas-cart');
    if (!oc) return;
    var foot = oc.querySelector('.offcanvas-footer');
    if (!foot || foot.dataset.nnCompact) return;
    var sub = foot.querySelector('#offcanvas-cart-subtotal');
    var btn = foot.querySelector('.btn-checkout');
    if (!sub || !btn) return;
    foot.dataset.nnCompact = '1';
    var b = sub.querySelectorAll('b');
    var total = b.length ? b[b.length - 1].textContent.trim() : '';
    sub.classList.add('nn-hide');
    var small = foot.querySelector('p.small.text-muted');
    if (small) small.classList.add('nn-hide');
    if (total && !btn.querySelector('.nn-btn-total')) {
      var sp = document.createElement('span');
      sp.className = 'nn-btn-total';
      sp.textContent = '· ' + total;
      btn.appendChild(sp);
    }
    var form = foot.querySelector('form');
    if (form && !foot.querySelector('.nn-foot-note')) {
      var note = document.createElement('p');
      note.className = 'nn-foot-note';
      note.textContent = 'Envío gratis en RM con instalación · impuestos incluidos';
      form.insertAdjacentElement('afterend', note);
    }
  }
  function moveRev() {
    document.querySelectorAll('[data-nn-rev]').forEach(function (box) {
      var body = box.closest('.offcanvas-body');
      if (body && body.lastElementChild !== box) body.appendChild(box);
    });
  }
  function initCartUi() { moveRev(); compactFooter(); initRev(); }
  initCartUi();
  window.addEventListener('updated.ecomify.cart', initCartUi);
  document.addEventListener('shown.bs.offcanvas', function () { initCartUi(); });

  document.addEventListener('click', function (e) {
    var d = e.target.closest && e.target.closest('[data-nn-disc-apply]');
    if (d) { e.preventDefault(); applyDiscount(d); return; }
    var b = e.target.closest && e.target.closest('[data-nn-desp-open]');
    if (b) { e.preventDefault(); open(b); }
  });
})();
